const Config = {
	WORK_ORDERS_PAGE_SIZE: 30,
	// BACKEND_URL: 'http://localhost:9000/',
	/*BACKEND_URL: 'https://rest.lendcoserver.com/',*/
	// ENV: 'test',
	BACKEND_URL: 'https://6mx0owg2p6.execute-api.us-west-2.amazonaws.com/prod/',
	ENV: 'prod',

	ALGOLIA_APP_ID: 'CEKD27JLAB',
	ALGOLIA_SEARCH_KEY: 'f83a779f7119a08eb1c41143b2c221bb',
	AWS_REGION: 'us-west-2',
	AWS_ACCESS_KEY_ID: "AKIAW4FID5CQEU7KQ47H",
	AWS_SECRET_ACCESS_KEY: "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",
	GOOGLE_API_KEY: 'AIzaSyD7TvtbLrowT1JdCd6IIsRIo1qqKjhrLsY'
}

export default Config
